<template>
	<select :id="listId" class="select attribute-editor dictionary-list" :data-maxlength="maxLength" :value="attributeValue" :disabled="lockedEdit">
		<option value=""></option>
		<template v-if="prevValuesDictionary.values.length === 0">
			<option v-for="value in prevValuesDictionary.valuesGroups[lang]" :value="value">{{ $t(value) }}</option>
		</template>
		<template v-else>
			<option v-for="value in prevValuesDictionary.values" :value="value">{{ $t(value) }}</option>
		</template>
	</select>
</template>

<script>
import { Fragment } from 'vue-fragment'

export default {
	components: {
		Fragment
	},
	name: 'PrevValuesDictionaryList',
	props: [
		'attributeName',
		'isMultiple',
		'maxLength',
		'prevValuesDictionary',
		'lang',
		'index',
		'itemData',
		'lockedEdit'
	],
	data () {
		return {
			listId: this.isMultiple ? this.attributeName + '__' + this.lang : this.attributeName,
		}
	},
	computed: {
		attributeValue: function () {
			if (this.itemData) {
				if (this.prevValuesDictionary.values.length === 0) {
					return this.itemData[this.lang]
				} else {
					return this.itemData
				}
			} else {
				return ''
			}
		}
	}
}
</script>

<style scoped>

</style>
